import { Ability, AbilityBuilder } from '@casl/ability'

export const ability = new Ability()

export function defineRulesFor(user) {
  const { can, rules } = AbilityBuilder.extract()

  user.roles.forEach(role => {
    switch (role) {
      case 'ROLE_ADMIN':
        can('manage', 'all')
        break
      case 'ROLE_MANAGER':
        can('cart', 'submit')
        can('manage', 'company')
        break
      case 'ROLE_SELLER':
        break
    }
  })

  return rules
}
